import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import { logError } from "@entrilia/shared/logging";
import type { FieldAttribute } from "../../../api/types/objectTypes";
import type { EntityFieldComponentProps, EntityFieldComponentPropsBase } from "../entityFieldTypes";
import { getInvalidFieldValueError } from "../helpers";
import EntityFieldTypeWrapper from "./EntityFieldTypeWrapper";
import EntityTextFieldComponent from "./EntityTextFieldComponent";

const EntityGuidFieldComponent = ({
  value,
  fieldId,
  fieldConfiguration,
  fieldAttributes,
  fieldInputId,
}: EntityFieldComponentProps<string>) => {
  const guidFieldAttributes: FieldAttribute[] = [...(fieldAttributes ?? []), "ReadOnly"]; // GUID fields should be read-only

  return (
    <EntityTextFieldComponent
      value={value ?? ""}
      fieldId={fieldId}
      fieldConfiguration={fieldConfiguration}
      fieldAttributes={guidFieldAttributes}
      fieldInputId={fieldInputId}
      onChange={() => undefined}
      displayHoverComponent={value ? <CopyToBufferButton textToCopy={value} /> : null}
    />
  );
};

const EntityGuidField = ({
  value,
  fieldId,
  fieldConfiguration,
  fieldAttributes,
  onChange,
  fieldInputId,
}: EntityFieldComponentPropsBase) => {
  if (typeof value !== "string" && value !== undefined && value !== null) {
    logError(getInvalidFieldValueError(fieldId, fieldConfiguration?.$type, value), "[EntityGuidField]");
    return null;
  }

  return (
    <EntityFieldTypeWrapper
      value={value}
      fieldId={fieldId}
      fieldConfiguration={fieldConfiguration}
      fieldAttributes={fieldAttributes}
      onChange={onChange}
      fieldInputId={fieldInputId}
      ComponentToRender={EntityGuidFieldComponent}
    />
  );
};

export default EntityGuidField;
